import userController from './controller/user/userController';
import postController from './controller/post/postController';
import messageController from './controller/message/messageController';

export default {
  async user(context, payload) {
    let result = false;

    if (payload !== undefined && payload !== null && payload !== '') {
      const scope = typeof payload.scope === 'string' && payload.scope !== null && payload.scope !== '' ? payload.scope : '';
      const data = typeof payload.data !== 'undefined' && payload.data !== null && payload.data !== '' ? payload.data : '';

      switch (scope) {

        case 'login':
          result = await userController.login(data);
          break;
          
        case 'uploadPhotoProfile':
          result = await userController.uploadPhotoProfile(data);
          break;
          
        case 'updateProfile':
          result = await userController.updateProfile(data);
          break;
          
        case 'deleteUser':
          result = await userController.deleteUser(data);
          break;
          
        case 'importUser':
          result = await userController.importUser(data);
          break;

        default:
      }
    }

    return result;
  },
  async post(context, payload) {
    let result = false;

    if (payload !== undefined && payload !== null && payload !== '') {
      const scope = typeof payload.scope === 'string' && payload.scope !== null && payload.scope !== '' ? payload.scope : '';
      const data = typeof payload.data !== 'undefined' && payload.data !== null && payload.data !== '' ? payload.data : '';

      switch (scope) {

        case 'create':
          result = await postController.create(data);
          break;

        case 'load':
          result = await postController.load(data);
          break;

        case 'createComment':
          result = await postController.createComment(data);
          break;

        case 'likePost':
          result = await postController.likePost(data);
          break;

        case 'dislikePost':
          result = await postController.dislikePost(data);
          break;

        case 'search':
          result = await postController.search(data);
          break;

        case 'searchFilter':
          result = await postController.searchFilter(data);
          break;

        case 'pinPost':
          result = await postController.pinPost(data);
          break;

        case 'unpinPost':
          result = await postController.unpinPost(data);
          break;

        case 'reportPost':
          result = await postController.reportPost(data);
          break;

        case 'visitProfile':
          result = await postController.visitProfile(data);
          break;

        case 'sharePost':
          result = await postController.sharePost(data);
          break;

        case 'mostLikedPost':
          result = await postController.mostLikedPost(data);
          break;

        case 'mostDislikedPost':
          result = await postController.mostDislikedPost(data);
          break;

        case 'mostSharedPost':
          result = await postController.mostSharedPost(data);
          break;

        case 'getReportedPost':
          result = await postController.getReportedPost(data);
          break;

        case 'deleteReport':
          result = await postController.deleteReport(data);
          break;

        case 'deletePost':
          result = await postController.deletePost(data);
          break;

        case 'getAsset':
          result = await postController.getAsset(data);
          break;

        case 'exportData':
          result = await postController.exportData(data);
          break;

        default:
      }
    }

    return result;
  },
  async message(context, payload) {
    let result = false;

    if (payload !== undefined && payload !== null && payload !== '') {
      const scope = typeof payload.scope === 'string' && payload.scope !== null && payload.scope !== '' ? payload.scope : '';
      const data = typeof payload.data !== 'undefined' && payload.data !== null && payload.data !== '' ? payload.data : '';

      switch (scope) {
        case 'load':
          result = await messageController.load(data);
          break;

        case 'loadOne':
          result = await messageController.loadOne(data);
          break;
          
        case 'send':
          result = await messageController.send(data);
          break;
          
        case 'create':
          result = await messageController.create(data);
          break;
          
        case 'unreadMessage':
          result = await messageController.unreadMessage(data);
          break;
          
        case 'loadNotification':
          result = await messageController.loadNotification(data);
          break;
          
        case 'markSeen':
          result = await messageController.markSeen(data);
          break;

        default:
      }
    }

    return result;
  },
};
